export const TEXT_LENGTH = '65535';
